import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import Image from "react-bootstrap/Image";

function Secondaboutimg() {
  const captionStyleheader = {
    textAlign: "center",
    padding: "2px",
    marginTop: "2rem",
    marginBottom: "5rem",
  };

  const captionTextStyle3 = {
    fontSize: "1.1rem",
    textOverflow: "ellipsis",
    color: "black",
    fontWeight: 600,
    textAlign: "center",
    lineHeight: "2.5",
    marginBottom: "2rem", // Add margin for responsiveness
  };

  const imageStyle = {
    objectFit: "cover",
    filter: "opacity(2) brightness(1)",
    width: "100%", // Set the width to 100% to match the card width
  };

  return (
    <Container
      fluid
      style={{
        marginBottom: "10px",
        height: "auto",
        marginTop: "100px",
      }}
    >
      <Container
        style={{ padding: "2px", marginTop: "50px", ...captionStyleheader }}
      >
        <Row className="justify-content-center">
          {/* Show single column on xs and sm screens */}
          <Col xs={12} sm={12} md={12} lg={5}>
            <Image
              src={process.env.PUBLIC_URL + "/assets/images/Aboutimg1.png"}
              alt=""
              style={{ ...imageStyle, width: "100%" }}
            />
          </Col>
          {/* Show two columns on md, lg, and xl screens */}
          <Col xs={12} sm={12} md={12} lg={6}>
            <Container fluid>
              <p
                className="semi-bold-text"
                style={{
                  ...captionTextStyle3,
                  width: "100%",
                  textAlign: "justify",
                  marginBottom: "1rem", // Add margin at the bottom for larger screens
                  marginRight: "0", // Reset right margin
                  marginTop: "1rem"
                }}
              >
                Welcome to our world, where a deep understanding of the human element in business meets cutting-edge expertise. We are a collective of seasoned professionals hailing from diverse fields - HR, Business, Academia, Technical domains, Training & Development, and Assessment. Our roots are in the GCC, but our experience and networks span globally, giving us a unique, multifaceted perspective. At the heart of our approach lies evidence-based solutions, born from meticulous research and an intimate understanding of the ever-evolving industry dynamics. We're not just in tune with the changing needs of companies; we also empathize with the aspirations and challenges of job applicants. This dual insight allows us to craft solutions that are as compassionate as they are competent.
              </p>
            </Container>
          </Col>
        </Row>
      </Container>
    </Container>
  );
}

export default Secondaboutimg;
